module.exports = __webpack_public_path__ + "img/chengjiu.1a2862e6.png";